import { Accordion, AccordionSummary, Grid, useTheme } from "@mui/material"
import { FC } from "react"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { H3 } from "components/Typography";
import { EmployeeEntity, ShiftAssignmentEntity, ShiftDetailEntity, ShiftEntity } from "api/generated";
import { format } from "date-fns";

interface DataProps {
    employee: EmployeeEntity,
    modifiedShifts: ShiftAssignmentEntity[]
}


const ToBePublishedAccordion: FC<DataProps> = ({ employee, modifiedShifts }) => {

    const theme = useTheme();

    const timeOption: Intl.DateTimeFormatOptions = {
        timeZone: 'UTC',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h24',
    }

    const formatShiftAssignment = (s: ShiftAssignmentEntity) => {

        const shiftDetail = ((s as any).shiftDetail as ShiftDetailEntity);

        const shift = (shiftDetail as any).shift as ShiftEntity;

        const workPosition = shiftDetail.workPosition;

        if (!(shiftDetail && shift && workPosition)) // or !shiftDetail || !shift || !workPosition for De Morgan (:
            return;

        const startTime = new Date(shiftDetail.startTime ?? shift.startTime).toLocaleTimeString(undefined, timeOption);

        const endTime = new Date(shiftDetail.endTime ?? shift.endTime).toLocaleTimeString(undefined, timeOption);

        const hasBreak = !!shiftDetail.breakStart && !!shiftDetail.breakEnd


        return (
            <Grid container width={'80%'}
             color={s.deleted ? theme.palette.error.main : theme.palette.success.main} justifyContent={'space-between'}>
                <Grid item >
                    {
                        workPosition.name + ': ' + format(new Date(s.date), 'dd/MM')


                    }
                </Grid>
                <Grid item >
                    {
                        (hasBreak ?
                            (
                                startTime + ' - ' +
                                new Date(shiftDetail.breakStart).toLocaleTimeString(undefined, timeOption)
                                + '  ' +
                                new Date(shiftDetail.breakEnd).toLocaleTimeString(undefined, timeOption)
                                + ' - ' + endTime
                            ) :
                            (
                                startTime + ' - ' + endTime
                            )
                        )
                    }
                </Grid>
            </Grid>

        )
    }

    return (
        <Accordion key={employee.id}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Grid container alignContent={"center"} justifyContent={"center"} padding={"10px"}>
                    <Grid item xs={10} zeroMinWidth>
                        <H3
                            style={{
                                textOverflow: "ellipsis",
                                wordBreak: "break-word",
                                overflow: "hidden",
                                minWidth: "0",
                                maxWidth: "100%",
                                display: "flex",
                                padding: "5px 10px",
                            }}
                        >
                            {employee.firstName + ' ' + employee.lastName}
                        </H3>
                    </Grid>
                    <Grid item xs={1}>
                        <H3
                            style={{
                                textAlign: "center",
                                display: "inline-block",
                                color: theme.palette.success.main,
                            }}
                        >
                            {'+' + modifiedShifts.filter(s => !s.deleted).length}
                        </H3>
                    </Grid>
                    <Grid item xs={1}>
                        <H3
                            style={{
                                textAlign: "center",
                                display: "inline-block",
                                color: theme.palette.error.main,
                            }}
                        >
                            {'-' + modifiedShifts.filter(s => s.deleted).length}
                        </H3>
                    </Grid>
                </Grid>
            </AccordionSummary>
            <Grid container>
                {
                    modifiedShifts.map(shift => {
                        return (
                            <Grid item xs={12} paddingLeft={5}>
                                {formatShiftAssignment(shift)}
                            </Grid>
                        )
                    })
                }
            </Grid>
        </Accordion>
    )
}

export default ToBePublishedAccordion;